import React, { FC } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { QueryParamProvider } from 'use-query-params';

import { Snackbar } from './components';
import { GeneralLink } from './models/Routes';
import { store } from './redux';
import AuthorizedLayout from './routes/AuthorizedLayout';
import AuthorizedRoute from './routes/AuthorizedRoute';
import Error from './scenes/unauthorised/Error';
import LoginAsUser from './scenes/unauthorised/LoginAsUser';
import Logout from './scenes/unauthorised/Logout';

import 'react-perfect-scrollbar/dist/css/styles.css';
import './styling/_default.scss';

const App: FC = () => {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <QueryParamProvider ReactRouterRoute={Route}>
          <Switch>
            <Route path={GeneralLink.ERROR}>
              <Error />
            </Route>
            <Route path={GeneralLink.LOGOUT}>
              <Logout />
            </Route>
            {(process.env.REACT_APP_ENV === 'development' || process.env.REACT_APP_ENV === 'local') && (
              <Route path={GeneralLink.LOGIN_AS_USER}>
                <LoginAsUser />
              </Route>
            )}
            <AuthorizedRoute path='/' component={AuthorizedLayout} />
          </Switch>
          <Snackbar />
        </QueryParamProvider>
      </BrowserRouter>
    </Provider>
  );
};

export default App;
